import { Classes } from "@blueprintjs/core";
import styled from "styled-components";

import {
  HexButton,
  HexButtonWithDropdown,
  HexDropdownButton,
  HexMenu,
} from "../../hex-components";
import { ToggleHeader } from "../../hex-components/HexCollapse";

export const MorePopoverMenu = styled(HexMenu)`
  &&& {
    min-width: 180px;
  }
`;

export const SplitCreateButton = styled(HexButtonWithDropdown)`
  opacity: 0;
  transition: opacity ${({ theme }) => theme.animation.duration}
    ${({ theme }) => theme.animation.easing};

  .${Classes.BUTTON} {
    padding: 0 5px;
    min-height: 20px;
    min-width: unset;
    box-shadow: none !important;

    &:hover {
      background-color: ${({ theme }) => theme.hoverColor};
    }
  }

  && ${HexDropdownButton} {
    padding: 0 1px;
  }

  &&&&&&& .${Classes.ICON} {
    margin: 0 -4px;
  }
`;

export const ActionButtons = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const MenuCreateButton = styled(HexButton)`
  opacity: 0;
  min-height: unset !important;

  .${Classes.MENU_ITEM}:hover & {
    opacity: 1;
  }

  &:hover {
    background-color: ${({ theme }) => theme.hoverColor} !important;
  }
`;

export const TooltipContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CreateActionButton = styled(HexButton)`
  opacity: 0;
  transition:
    opacity ${({ theme }) => theme.animation.duration}
      ${({ theme }) => theme.animation.easing},
    background-color ${({ theme }) => theme.animation.duration}
      ${({ theme }) => theme.animation.easing};

  &:hover {
    background-color: ${({ theme }) => theme.hoverColor} !important;
  }
`;

export const SidebarEntryRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &:hover ${CreateActionButton}, &:hover ${SplitCreateButton} {
    opacity: 1;
  }
`;

export const FavoritesWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
  margin-top: 4px;

  ${ToggleHeader} {
    padding-left: 6px;
  }

  ${ToggleHeader} svg {
    opacity: 0.6;
    transition: opacity ${({ theme }) => theme.animation.duration}
      ${({ theme }) => theme.animation.easing};
  }

  ${ToggleHeader}[aria-expanded="true"] svg {
    opacity: 0;
  }

  ${ToggleHeader}[aria-expanded="true"]:hover svg {
    opacity: 0.6;
  }
`;
